<template>
  <div class="w-100 flex-v-center flex-between login-wrapper" :class="{'-center': showLoginModal}">
    <div v-if="!showLoginModal" :class="{'-show': isLogged && !isPremium}" class="login-wrapper-header text-right w-100">
      <a href="https://kidsmode.browserlock.net/">{{$lang.messages.get_premium_modal.help}}</a></div>
    <div class="text-center w-100 login-popup">
      <a href="/app">
        <img alt="logo" src="./../assets/img/logo.svg" class="logo mb-2">
      </a>
      <div v-show="!isLogged && showLoginModal" id="firebaseui-auth-container"></div>
      <div v-show="!isPremium && !showLoginModal">
        <p class="text-bold text-center text-lg mb-1">{{$lang.messages.get_premium_modal.mobile_only_for_premium}}</p>
        <div class="text-center mb-1">
          <button class="btn btn-premium" @click="getPremium">{{$lang.messages.get_premium}}</button>
        </div>
        <div class="text-center">
          <span class="premium-currency">$</span><span class="premium-value">2.</span><span class="premium-cents">99</span>
          <span class="premium-forever">{{$lang.messages.get_premium_modal.monthly}}</span>
        </div>
      </div>
    </div>
    <div v-show="!isLogged && !isPremium && !showLoginModal" class="text-center">
      <button class="btn btn-main w-100" @click="getPremium">{{$lang.messages.get_premium_modal.already_have_premium}}</button>
      <span class="mt-1 login-link" @click="getPremium">{{$lang.messages.sign_in}}</span>
    </div>
    <div class="text-center" v-show="isLogged && !isPremium">
      <div class="header-text text-bold">{{ userEmail }}</div>
      <div><a href="#" class="btn btn-secondary" @click.prevent="signOut">{{$lang.messages.sign_out}}</a></div>
    </div>
    <GetPremiumModal v-if="showGetPremium"
                     v-on:closepremiummodal="showGetPremium = false"
                     v-on:premiumispurchased="showPremiumIsPurchased = true"
                     v-on:updatesettings="savesettings"/>
  </div>
</template>

<script>
import firebase from "firebase/app";

import * as firebaseui from "firebaseui";
import 'firebaseui/dist/firebaseui.css'
import GetPremiumModal from "@/components/GetPremiumModal";
import {db} from "@/fb/firebase";
import {reportEvent, sendRegistrationEmail} from "@/helpers/utils";

export default {
  name: 'Login',
  components: {GetPremiumModal},
  data: function () {
    return {
      userEmail: null,
      isPremium: false,
      isLogged: false,
      showGetPremium: false,
      showLoginModal: false,
      unsubscribeFB: null,
      newUserLogged: '',
      showPremiumIsPurchased: false
    }
  },
  mounted () {
    const $this = this;
    const ui = firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(firebase.auth());
    this.unsubscribeFB = firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        if (!user.email) {
          ui.start('#firebaseui-auth-container', {
            signInOptions: [
              {
                provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
                requireDisplayName: false,
              }
            ],
            callbacks: {
              // eslint-disable-next-line no-unused-vars
              signInSuccessWithAuthResult(authResult, redirectUrl) {
                console.log(authResult);
                if (authResult.additionalUserInfo.isNewUser) {
                  reportEvent('createAccount', {'email': authResult.user.email});
                  $this.$analytics.fbq.event('CompleteRegistration')
                  this.$gtag.event('conversion', {
                    'send_to': 'AW-311471832/mQ27CImxlPACENjdwpQB'
                  })
                  sendRegistrationEmail(authResult.user.email)
                  $this.newUserLogged = true
                } else {
                  $this.loggedHandle(authResult.user)
                  reportEvent('userSignIn', {'userID': authResult.user.uid, 'isAnonymous': false, 'email': authResult.user.email})
                }

                return false;
              },
              signInFailure(error) {
                if (error.code !== 'firebaseui/anonymous-upgrade-merge-conflict') {
                  return Promise.resolve();
                }
                var cred = error.credential;
                return firebase.auth().signInWithCredential(cred);
              }
            },
          });
        } else  {
          this.loggedHandle(user);
        }
      } else {
        this.isLogged = false;
      }
    })
  },

  destroyed() {
    if (this.unsubscribeFB) {
      this.unsubscribeFB();
    }
  },

  methods: {
    signOut () {
      firebase.auth().signOut()
    },
    loggedHandle(user) {
      this.isLogged = true;
      this.showLoginModal = false
      this.userEmail = user.email
      firebase.database().ref('users/' + user.uid + '/settings/isPremium/').get().then((snapshot) => {
        if (snapshot.exists()) {
          this.isPremium = snapshot.val();
          if (this.isPremium && this.$route.path !== '/') {
            this.$router.push('/')
          }
        }
      })
    },
    getPremium() {
      if (this.isLogged){
        this.showGetPremium = true
        reportEvent('premium_dialog_open')
      } else {
        this.showLoginModal = true
      }
    },
    savesettings (settings) {
      db.ref('users/' + firebase.auth().currentUser.uid).child('settings').update(settings).then(() => {
        this.$router.push('/?showbuypremium='+this.isPremium+'&newuser=' + this.newUserLogged)
      })
    },
  },
}
</script>

<style lang="scss">
@import "../assets/styles/helpers";
@import "../assets/styles/themes";
@import "../assets/styles/kid";

.premium {
  &-currency {
    font-size: 29px;
    color: #27272C;
  }

  &-value {
    font-size: 39px;
    color: #27272C;
  }

  &-cents {
    font-size: 23px;
    vertical-align: 10px;
    color: #27272C;
  }

  &-forever {
    color: #27272C;
    display: inline-block;
    font-size: 12px;
    text-transform: uppercase;
    font-weight: 700;
    padding: 15px;
    position: relative;
    transform-origin: 0 0;
    transform: rotate(-14deg) translate(-30px, 6px);

    &:before,
    &:after {
      content: "";
      width: 40%;
      height: 100%;
      display: block;
      background: url("../assets/img/forever-bg-gray.svg") no-repeat left bottom;
      position: absolute;
      left: 0;
      bottom: 0;
      transform: rotate(12deg);
    }

    &:after {
      left: auto;
      right: 0;
      top: 0;
      bottom: auto;
      transform: rotate(192deg);
    }
  }
}

.login-wrapper {
  padding: 50px;
  background: #F5F7FB;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;

  @include responsive-below($sm){
    padding: 85px 20px;
  }

  &.-center {
    justify-content: center;
  }

  &-header {
    opacity: 0;
    visibility: hidden;

    &.-show {
      opacity: 1;
      visibility: visible;
    }
  }

  .header-text {
    padding-right: 0;
    margin-bottom: 16px;
  }
}

.login-popup {
  max-width: 500px;
}
</style>
